import "%modules%/header/header";
import "%modules%/footer/footer";

import "%modules%/post/post";
import "%modules%/case/case";
import "%modules%/team/team";
import "%modules%/main-slider/main-slider";
import "%modules%/path/path";

import "%modules%/project/project";

import "%modules%/modal/modal";
